<template>
  <div id="logo">
    <span>niller</span><span class="grey">.xyz</span>
  </div>
</template>

<script>
export default {
  name: 'Logo'
};
</script>

<style lang="scss" scoped>
#logo {
  font-size: 20vmin;
  font-family: "Roboto", sans-serif;
  color: #4fc3f7;
  text-align: center;
  padding: 0;
  margin: 0;
  .grey {
    color: #e0e0e0;
  }
}
</style>
